<script setup lang="ts">
import { ref, watch, Ref } from 'vue';
import { Snack, useSnackbarStore } from '@/store/snackbar';
import { storeToRefs } from 'pinia';
const store = useSnackbarStore();
const { queue } = storeToRefs(store);

const snackbar = ref(false);
const timeout = ref(4000);
const snack: Ref<Snack> = ref({ text: '' });

watch(queue, () => {
  if (!snackbar.value) {
    handle();
  }
});

watch(snackbar, async (value: boolean) => {
  if (!value) {
    await new Promise((r) => setTimeout(r, 200));
    handle();
  }
});

function handle() {
  if (snackbar.value) return;
  const newSnack = store.shift();
  if (!newSnack) return;
  snack.value = newSnack;
  timeout.value = snack.value.timeout || 4000;
  snackbar.value = true;
}
</script>

<template>
  <v-snackbar
    v-model="snackbar"
    :timeout="timeout"
    min-width="0"
    color="surface"
  >
    {{ snack.text }}

    <template v-slot:actions>
      <v-btn
        v-if="snack.closable || false"
        variant="plain"
        color="primary"
        @click="snackbar = false"
        style="opacity: 1"
      >
        Close
      </v-btn>
    </template>
  </v-snackbar>
</template>
